import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import posthog from 'posthog-js';
import App from './App.tsx';
import './index.css';

const posthogKey = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
const posthogHost = import.meta.env.VITE_POSTHOG_HOST as string | undefined;

if (import.meta.env.PROD && posthogKey) {
  posthog.init(posthogKey, {
    api_host: posthogHost ?? 'https://app.posthog.com',
    capture_pageview: true,
    autocapture: true,
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);

if ('serviceWorker' in navigator && 
    (window.location.protocol === 'https:' || window.location.hostname === 'localhost')) {
  window.addEventListener('load', () => {
    const swUrl = import.meta.env.BASE_URL + 'sw.js';
    navigator.serviceWorker.register(swUrl)
      .then(registration => {
        console.log('ServiceWorker registreret:', registration);
      })
      .catch(error => {
        console.log('ServiceWorker registrering fejlede:', error);
      });
  });
} 
